<div class="header">
    <h4> <strong> {{ "AccountAlias" | localize }} </strong></h4>
</div>
<div>
    <div class="text-align-left mr-auto">
        <div *ngFor="let alias of data">
            <div>               
                    {{alias}}
            </div>
        </div>
    </div>
</div>
<div class="row mt-4">
    <div class="form-actions col-xs-12 ">
        <button class="btn btn-thm-black min-w-200 mar-lft " type="button"  (click)="close()">
            {{ "Cancel" | localize }}
        </button>
    </div>
</div>